import React from 'react'
import { Alert, Modal } from 'react-bootstrap'

interface ErrorDialogProps {
	show: boolean
	onHide: () => void
	title: string
	errors: string[]
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ show, onHide, title, errors }) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<p>Please fill the Mandatory fields as shown below:</p>
					<ul>
						{errors.map((error, index) => (
							<li key={index}>{error}</li>
						))}
					</ul>
				</Alert>
			</Modal.Body>
			<Modal.Footer>
				<button className="btn btn-secondary" onClick={onHide}>
					Close
				</button>
			</Modal.Footer>
		</Modal>
	)
}

export default ErrorDialog